export default __webpack_public_path__ + "static/media/1673.25468940.png";